




import Vue from 'vue'
import ProcedureLayout from '@/UI/Auction/Procedure/ProcedureLayout.vue'
import { StepValidation } from '@/UI/Shared/StepValidation'

export default Vue.extend({
  name: 'Procedure',
  components: { ProcedureLayout },
  data () {
    return {
      continuar: false
    }
  },
  computed: {
    validateFields (): StepValidation {
      if (this.continuar) {
        return {
          validForm: true,
          step: 3
        }
      } else {
        return {
          validForm: false,
          step: 3
        }
      }
    }
  },
  watch: {
    continuar () {
      this.$emit('validForm', this.validateFields)
    }
  }
})
